// extracted by mini-css-extract-plugin
export default {"popup_window":"Gallery_popup_window__slWPI","close_btn":"Gallery_close_btn__QzrsO","gallery_popup":"Gallery_gallery_popup__W1Fd5"};